import React, { Component } from 'react';
import Category from './helpers/Category';

export default class Entertainment extends Component {
  lgHeader = {
    id: 'lgHeader',
    src: require('./images/entertainment/txt_lg_EntertainmentRelax.png'),
    left: 0,
    width: 732,
    height: 35
  };
  smHeader = {
    id: 'smHeader',
    src: require('./images/entertainment/txt_sm_EntertainmentRelax.png'),
    width: 222,
    height: 222
  };
  cat1Buttons = [
    {
      id: 'chromecast',
      to: '/staycast',
      highlight: require('./images/entertainment/txt_GoogleChromecast_HL.png'),
      unhighlight: require('./images/entertainment/txt_GoogleChromecast_UH.png'),
      alt: 'Chromecast'
    },
    {
      id: 'movies',
      to: '/movies',
      highlight: require('./images/entertainment/txt_Movies_HL.png'),
      unhighlight: require('./images/entertainment/txt_Movies_UH.png'),
      alt: 'Movies'
    },
    {
      id: 'watchTv',
      to: '/ipg',
      highlight: require('./images/mydashboard/txt_WatchTV_HL.png'),
      unhighlight: require('./images/mydashboard/txt_WatchTV_UH.png'),
      alt: 'Watch Tv'
    },
    {
      id: 'relaxationChannel',
      to: '/ftg/relaxation',
      highlight: require('./images/entertainment/txt_RelaxationChannel_HL.png'),
      unhighlight: require('./images/entertainment/txt_RelaxationChannel_UH.png'),
      alt: 'Relaxation Channel'
    },
    {
      id: 'Music',
      to: '/music',
      highlight: require('./images/entertainment/txt_Music_HL.png'),
      unhighlight: require('./images/entertainment/txt_Music_UH.png'),
      alt: 'Music'
    },
    {
     id: 'spritualAudio',
     to: '/spiritual',
     highlight: require('./images/entertainment/txt_SpiritualAudio_HL.png'),
     unhighlight: require('./images/entertainment/txt_SpiritualAudio_UH.png'),
     alt: 'Spritual Audio'
    },
    {
      id: 'whiteNoise',
      to: '/ftg/white_noise',
      highlight: require('./images/entertainment/txt_WhiteNoise_HL.png'),
      unhighlight: require('./images/entertainment/txt_WhiteNoise_UH.png'),
      alt: 'White Noise'
    },
    {
      id: 'sleepTimer',
      to: '/sleep_timer',
      highlight: require('./images/entertainment/txt_SleepTimer_HL.png'),
      unhighlight: require('./images/entertainment/txt_SleepTimer_UH.png'),
      alt: 'Sleep Timer'
    }
  ];

  render() {
    const currentHighlight = this.props.current === this.props.movingPos && this.props.current === -3;
    const shrinkMe = this.props.current === -3 && this.props.movingPos === -2;
    const growMe = this.props.current === -2 && this.props.movingPos === -3;

    return (
      <Category
        largeHeader={this.lgHeader}
        smallHeader={this.smHeader}
        serviceLinks={this.cat1Buttons}
        shrinkGrow={this.props.shrinkGrow}
        hlState={this.props.hlState}
        movedir={this.props.movedir}
        currentHighlight={currentHighlight}
        shrinkMe={shrinkMe}
        growMe={growMe}
        disabled={this.props.disabled}
      />
    );
  }
}
